<template>
  <nav class="an ins-root" aria-label="Основное меню">
    <div class="an-bar">
      <router-link class="an-brand" to="/" aria-label="На главную">
        <span class="an-mark" aria-hidden="true">td</span>
        <span class="an-word">trends<span class="an-word-dim">·ds</span></span>
      </router-link>

      <button type="button" class="an-burger" @click="open = !open"
              :aria-expanded="String(open)" aria-label="Меню">
        <span aria-hidden="true"></span><span aria-hidden="true"></span><span aria-hidden="true"></span>
      </button>

      <div class="an-groups" :class="{ 'is-open': open }">
        <div v-for="group in groups" :key="group.title" class="an-group">
          <span class="an-group-title">{{ group.title }}</span>
          <div class="an-links">
            <router-link
              v-for="link in group.links" :key="link.to"
              class="an-link" :to="link.to" @click="open = false"
            >{{ link.label }}</router-link>
          </div>
        </div>
      </div>

      <div class="an-actions">
        <button type="button" class="an-icon" @click="onTheme"
                :title="dark ? 'Светлая тема' : 'Тёмная тема'"
                :aria-label="dark ? 'Светлая тема' : 'Тёмная тема'">
          <span class="an-icon-glyph">{{ dark ? '☀' : '☾' }}</span>
        </button>
        <button type="button" class="an-exit" @click="logout">Выйти</button>
      </div>
    </div>
  </nav>
</template>

<script>
import axios from 'axios';
import { restoreTheme, toggleTheme, watchTheme } from '@/utils/theme';

export default {
  name: 'AppNav',
  data() {
    return {
      open: false,
      // Иконка показывает, куда переключимся, поэтому знать текущую тему надо
      // и после перезагрузки — отсюда чтение атрибута при монтировании.
      dark: false,
      unwatch: null,
      groups: [
        { title: 'Статистика', links: [
          { to: '/blockStat', label: 'Отчёт по блокам' },
          { to: '/insights', label: 'Инсайты' },
          { to: '/blockStatXlsx', label: 'XLSX' },
        ]},
        { title: 'Настройки', links: [
          { to: '/cabinet', label: 'Блоки и события' },
          { to: '/tokens', label: 'Токены' },
          { to: '/groupUtm', label: 'Группы UTM' },
        ]},
        { title: 'Инструменты', links: [
          { to: '/balansir', label: 'Балансировщик' },
          { to: '/phrases', label: 'Фразы и отчёты' },
        ]},
      ],
    };
  },
  methods: {
    onTheme() {
      this.dark = toggleTheme() === 'dark';
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('clientId');
      delete axios.defaults.headers.common['Authorization'];
      this.$router.push('/index');
    },
  },
  mounted() {
    restoreTheme();
    this.dark = document.documentElement.dataset.theme === 'dark';
    this.unwatch = watchTheme(next => { this.dark = next === 'dark'; });
  },
  beforeUnmount() {
    if (this.unwatch) this.unwatch();
  },
};
</script>

<style scoped>
.an {
  padding: 0;
  border-radius: 0;
  border-bottom: 1px solid var(--border);
  margin-bottom: 20px;
  /* Переменную перебивает страница, которой липкая шапка мешает: на «Отчёте
     по блокам» таблица специально занимает экран целиком, и шапка накрывала
     бы строку заголовков столбцов. */
  position: var(--app-nav-position, sticky);
  top: 0;
  z-index: 40;
  background: var(--surface-1);
  background: color-mix(in srgb, var(--surface-1) 82%, transparent);
  backdrop-filter: saturate(1.6) blur(12px);
  -webkit-backdrop-filter: saturate(1.6) blur(12px);
}
@supports not (color-mix(in srgb, red 50%, blue)) {
  .an { background: var(--surface-1); }
}
.an-bar {
  display: flex;
  align-items: center;
  gap: 8px 28px;
  padding: 10px 20px;
  flex-wrap: wrap;
}

.an-brand {
  display: flex; align-items: center; gap: 10px;
  color: var(--text-primary); text-decoration: none; flex: none;
}
.an-mark {
  width: 30px; height: 30px; border-radius: 9px;
  display: grid; place-items: center;
  font-size: 12.5px; font-weight: 700; letter-spacing: -0.03em;
  color: #fff;
  background: var(--accent);
  background: linear-gradient(140deg, var(--accent), var(--cmp));
  box-shadow: 0 2px 10px var(--brush-fill);
}
.an-word { font-size: 15px; font-weight: 700; letter-spacing: -0.02em; }
.an-word-dim { color: var(--text-muted); font-weight: 500; }

.an-groups { display: flex; gap: 8px 24px; flex: 0 1 auto; flex-wrap: wrap; align-items: center; margin-right: auto; }
.an-group { display: flex; align-items: center; gap: 10px; }
.an-group-title {
  font-size: 9.5px; text-transform: uppercase; letter-spacing: .1em;
  color: var(--text-muted); white-space: nowrap;
}
.an-links {
  display: flex; gap: 2px;
  background: var(--page);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 3px;
}
.an-link {
  position: relative;
  font-size: 13px; color: var(--text-secondary); text-decoration: none;
  padding: 5px 12px; border-radius: 999px; white-space: nowrap;
  transition: color .15s, background .15s;
}
.an-link:hover { color: var(--text-primary); }
.an-link.router-link-active {
  color: #fff; font-weight: 600;
  background: var(--accent);
}

.an-actions { display: flex; gap: 8px; align-items: center; margin-left: auto; flex: none; }
.an-icon {
  width: 34px; height: 34px; border-radius: 10px;
  border: 1px solid var(--border); background: var(--surface-1);
  color: var(--text-secondary); cursor: pointer; font-family: inherit;
  display: grid; place-items: center; font-size: 15px; line-height: 1;
}
.an-icon:hover { color: var(--text-primary); border-color: var(--text-muted); }
.an-icon-glyph { display: block; }
.an-exit {
  border: 1px solid var(--border); background: var(--surface-1);
  color: var(--text-secondary); border-radius: 10px;
  padding: 7px 14px; font-size: 13px; font-family: inherit; cursor: pointer;
}
.an-exit:hover { color: var(--text-primary); border-color: var(--text-muted); }

.an-burger {
  display: none; width: 34px; height: 34px; border-radius: 10px;
  border: 1px solid var(--border); background: var(--surface-1);
  cursor: pointer; padding: 0;
  flex-direction: column; align-items: center; justify-content: center; gap: 4px;
}
.an-burger span {
  display: block; width: 15px; height: 1.5px; border-radius: 1px;
  background: var(--text-secondary);
}

@media (max-width: 1080px) {
  .an-burger { display: flex; }
  .an-actions { margin-left: 0; order: 2; }
  .an-burger { order: 3; margin-left: auto; }
  .an-groups {
    display: none; order: 4; width: 100%; flex-direction: column;
    align-items: flex-start; gap: 12px; padding: 12px 0 6px;
  }
  .an-groups.is-open { display: flex; }
  .an-group { flex-direction: column; align-items: flex-start; gap: 6px; }
  .an-links { flex-wrap: wrap; }
}

@media (prefers-reduced-motion: reduce) {
  .an-link { transition: none; }
}
</style>
